import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import UserIcon from "assets/images/userIconOn.png";
import InfoUser from "assets/images/infoUser.png";
import useInfoContext from "hooks/useInfoContext";
import { useTheme } from "@emotion/react";
import PlusIcon from "assets/images/plusIcon.png";
import ModalLoginUser from "./modalAddUser/loginUser";
import ModalCardIssuanceUser from "./modalAddUser/cardIssuanceUser";
import ModalRejisterUser from "./modalAddUser/registerUser";
import DeleteIcon from "assets/images/deleteIcon.png";
import CustomModalConfirm from "components/modalConfirm";
import ModalFinalConfirm from "./modalAddUser/finalConfirm";
import { toast } from "react-toastify";
import InfoError from "assets/images/infoError.png";
import { useGetEventRegistration, useRequestRemoveUser } from "hooks/event";
import CustomModalSuccess from "components/modalSuccses";
import { setRepTokenCookie } from "lib/Storage";

const RegisterConcert = () => {
  const [step, setStep] = useState(0);
  const [openModalAddUser, setOpenModalAddUser] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalDeleteUser, setOpenModalDeleteUser] = useState(false);
  const [openModalFinalConfirmUser, setOpenModalFinalConfirmUser] =
    useState(false);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [flagUpdate, setFlagUpdate] = useState(false);
  const [userRegistration, setUserRegistration] = useState();
  const [userInfoRegister, setUserInfoRegister] = useState();
  const previousStep = useRef(step);
  const isFirstRender = useRef(true);
  const { itemEventDetail, repToken, setRepToken, setUserIdRegistration } =
    useInfoContext();
  const { mutate: getEventRegistration, isLoading } = useGetEventRegistration();
  const { mutate: requestRemoveUser } = useRequestRemoveUser();
  const theme = useTheme();
  const handleOpenModalAddUser = () => {
    setOpenModalAddUser(true);
  };
  const handleOpenModalDeleteUser = () => {
    setOpenModalDeleteUser(true);
  };

  const handleOpenModalFinalConfirmUser = () => {
    setOpenModalFinalConfirmUser(true);
  };

  const handleOpenModalSuccess = () => {
    setOpenModalSuccess(true);
    setOpenModalFinalConfirmUser(false);
  };

  const handleCloseModalSuccess = () => {
    setOpenModalSuccess(false);
  };

  const handleClickUserRegister = (client) => {
    setStep(client?.stage);
    handleOpenModalAddUser();
    setUserInfoRegister(client?.clientInfo);
    setUserIdRegistration(client?.clientInfo._id);
  };

  const handleOpenModalDescription = () => {
    setOpenModalDescription(true);
  };
  const addInputField = () => {
    if (Object.keys(userRegistration?.registeredClients).length === 1) {
      handleOpenModalDescription();
    } else {
      handleOpenModalAddUser();
      setUserInfoRegister();
    }
  };

  const removeInputField = (client) => {
    handleOpenModalDeleteUser();
    setUserInfoRegister(client.clientInfo);
  };
  const confirmRemove = () => {
    if (userInfoRegister && repToken) {
      requestRemoveUser(
        {
          clientId: userInfoRegister._id,
          repToken: repToken,
        },
        {
          onSuccess: (response) => {
            if (response.status === "OK") {
              setRepToken(response.repToken);
              setRepTokenCookie(response.repToken);
              setOpenModalDeleteUser(false);
              setFlagUpdate(!flagUpdate);
            }
          },
          onError: (error) => {
            console.log("error delete user", error);
          },
        }
      );
    }
  };

  const handleCloseAddUser = () => {
    setOpenModalAddUser(false);
    setStep(0);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else if (previousStep.current !== step) {
      previousStep.current = step;
    }

    if (itemEventDetail) {
      getEventRegistration(itemEventDetail?._id, {
        onSuccess: (response) => {
          setRepToken(response.repToken);
          setRepTokenCookie(response.repToken);
          setUserRegistration(response.eventRegistration);
        },
        onError: (error) => {
          console.error("Error fetching event detail:", error);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, flagUpdate]);

  const handleContinue = () => {
    const allClientsStageFour = userRegistration
      ? Object.values(userRegistration?.registeredClients).every(
          (client) => client.stage === 4
        )
      : false;
    if (allClientsStageFour) {
      handleOpenModalFinalConfirmUser();
      return;
    }
    toast("لطفا تمام اطلاعات همراهان خود را وارد کنید", {
      icon: <img style={{ maxWidth: "100%" }} src={InfoError} alt="" />,
    });
  };

  return (
    <Box className="container-register-concert">
      {isLoading ? (
        <>
          <CircularProgress style={{ color: theme.palette.button.main }} />
        </>
      ) : (
        <>
          <Grid2 container columns={12} className="register-concert-page">
            <Grid2 className="grid-box">
              <Grid2 item size={{ xs: 12 }} className="top-box">
                <Grid2 container columns={12} className="container-info-box">
                  {userRegistration &&
                    Object.entries(userRegistration?.registeredClients).map(
                      ([key, client], index, array) => {
                        return (
                          <React.Fragment key={key}>
                            <Grid2
                              item
                              size={{ xs: 12 }}
                              className="info-box"
                              sx={{
                                cursor: index === 0 ? "default" : "pointer",
                              }}
                              onClick={
                                index > 0
                                  ? () => handleClickUserRegister(client)
                                  : undefined
                              }
                            >
                              <Grid2
                                item
                                size={{ xs: 1 }}
                                className="info-icon"
                              >
                                <img
                                  src={client.stage === 4 ? UserIcon : InfoUser}
                                  alt="User Icon"
                                />
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 10 }}
                                className="info-title"
                              >
                                {client.clientInfo?.fullname
                                  ? client.stage === 4
                                    ? client.clientInfo?.fullname
                                    : `${client.clientInfo?.fullname.substring(
                                        0,
                                        10
                                      )}...`
                                  : client.clientInfo?.phoneNumber}
                                &nbsp; {client.stage !== 4 && "-"} &nbsp;
                                <Typography
                                  variant="h6"
                                  className="user-status"
                                >
                                  {client.stage === 1
                                    ? "در انتظار ثبت نام"
                                    : client.stage === 2
                                    ? "در انتظار تایید هویت"
                                    : client.stage === 3
                                    ? "در انتظار تایید نهایی"
                                    : ""}
                                </Typography>
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 1 }}
                                className="info-delete"
                              >
                                {index > 0 && (
                                  <img
                                    src={DeleteIcon}
                                    className="button-delete"
                                    alt="Delete Icon"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      removeInputField(client);
                                    }}
                                  />
                                )}
                              </Grid2>
                            </Grid2>
                            {index < array.length - 1 && (
                              <hr
                                className="divider"
                                size={1}
                                color={theme.palette.defultText.main}
                                style={{ width: "100%" }}
                              />
                            )}
                          </React.Fragment>
                        );
                      }
                    )}

                  {userRegistration &&
                    Object.keys(userRegistration?.registeredClients).length <
                      6 && (
                      <>
                        <hr
                          className="divider"
                          size={1}
                          color={theme.palette.defultText.main}
                          style={{ width: "100%" }}
                        />
                        <Grid2 item size={{ xs: 12 }} className="add-user-box">
                          <Button
                            variant="contained"
                            className="add-user-button"
                            onClick={addInputField}
                          >
                            <img src={PlusIcon} alt="" />
                            <Typography variant="h6" className="add-user-text">
                              افزودن همراه
                            </Typography>
                          </Button>
                        </Grid2>
                      </>
                    )}
                </Grid2>
              </Grid2>
              <Grid2 item size={{ xs: 12 }} className="button-box">
              <Typography variant="h6" className="text-status">
                  رزرو شما با موفقیت انجام شده و تا زمان باز شدن امکان انتخاب
                  صندلی فرصت دارید لیست همراهان خود را تغییر دهید. طی روزهای
                  آینده امکان انتخاب صندلی طبق اولویت بندی بر اساس امتیازات شما
                  در «آکادمی آن» برای شما فراهم می شود. از طریق پیج رسمی «آکادمی
                  آن» در اینستاگرام (
                  <a
                    href="https://www.instagram.com/onacademyon_ir/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    onacademyon_ir
                  </a>
                  ) می توانید از اطلاعیه های بعدی با خبر شوید.
                </Typography>
                <Button variant="contained" onClick={handleContinue} disabled>
                  {/* ادامه */}
                  ثبت نهایی و رزرو صندلی (به زودی)
                </Button>
              </Grid2>
            </Grid2>
          </Grid2>
          {step === 0 && (
            <ModalLoginUser
              open={openModalAddUser}
              handleClose={handleCloseAddUser}
              step={step}
              setStep={setStep}
              clientInfo={userInfoRegister}
            />
          )}
          {step === 1 && (
            <ModalCardIssuanceUser
              open={openModalAddUser}
              handleClose={handleCloseAddUser}
              step={step}
              setStep={setStep}
              clientInfo={userInfoRegister}
            />
          )}
          {step === 2 && (
            <ModalRejisterUser
              open={openModalAddUser}
              handleClose={handleCloseAddUser}
              step={step}
              setStep={setStep}
              clientInfo={userInfoRegister}
            />
          )}
          {step === 3 && (
            <ModalFinalConfirm
              open={openModalAddUser}
              handleClose={handleCloseAddUser}
              step={step}
              setStep={setStep}
              fullnameUser={userInfoRegister?.fullname}
              clientInfo={userRegistration}
            />
          )}
          <CustomModalConfirm
            open={openModalDeleteUser}
            handleClose={setOpenModalDeleteUser}
            textTitle={`آیا از حذف ${
              userInfoRegister?.fullname || userInfoRegister?.phoneNumber
            } از لیست همراهان مطمئنید؟`}
            textConfirmButton="تایید"
            textCancleButton="لغو"
            functionConfirm={confirmRemove}
          />
          <CustomModalConfirm
            open={openModalDescription}
            handleClose={setOpenModalDescription}
            textTitle="شما می توانید 5 نفر از دوستان و آشنایان خود را به کنسرت شهرام شکوهی دعوت کنید."
            textBody="برای تکمیل مراحل به شماره همراه، نام لاتین، کدملی و تاریخ تولد همراهان خودنیاز دارید."
            textConfirmButton="افزودن همراه"
            textCancleButton="لغو"
            functionConfirm={() => {
              setOpenModalDescription(false);
              handleOpenModalAddUser();
            }}
          />
          <CustomModalConfirm
            open={openModalFinalConfirmUser}
            handleClose={setOpenModalFinalConfirmUser}
            textTitle="آیا از لیست نفرات همراه خود مطمئن هستید؟"
            textConfirmButton="تایید"
            textCancleButton="لغو"
            functionConfirm={() => {
              handleOpenModalSuccess();
            }}
          />
          <CustomModalSuccess
            open={openModalSuccess}
            close={handleCloseModalSuccess}
            title="درخواست شما با موفقیت ثبت شد!"
          />
        </>
      )}
    </Box>
  );
};

export default RegisterConcert;
